import { render, staticRenderFns } from "./TicketsPerAgent.vue?vue&type=template&id=1a6edf93&scoped=true&"
import script from "./TicketsPerAgent.vue?vue&type=script&lang=js&"
export * from "./TicketsPerAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6edf93",
  null
  
)

export default component.exports